import React from 'react';
import styles from './Header.scss';
import ThemeSwitcher from './ThemeSwitcher';
import LanguageSelector from './LanguageSelector';
import EditorExpandButton from './EditorExpandButton';
import CodeResetButton from './CodeResetButton';
import RunCodeButton from './RunCodeButton';

const FreeFormEditorHeader = ({
  theme,
  toggleTheme,
  selectedLanguage,
  languageList,
  switchLanguage,
  codeReset,
  disabled,
  submitCode,
  loading = false,
}) => {
  return (
    <div
      className={styles.EditorHeader}
      style={{
        backgroundColor: theme === 'vs-dark' ? '#1e1e1e' : '#fff',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <ThemeSwitcher
          theme={theme}
          toggleTheme={toggleTheme}
        />
        <LanguageSelector
          selectedLanguage={selectedLanguage}
          languageList={languageList}
          switchLanguage={switchLanguage}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <CodeResetButton
          theme={theme}
          codeReset={codeReset}
        />
        <RunCodeButton
          theme={theme}
          disabled={disabled}
          submitCode={submitCode}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default FreeFormEditorHeader;
